export default {"src":"/_next/static/media/exam.54d6aa94.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};